module.exports = "/_next/static/images/Vitamin_Rich-2da1d6373ffe351a5069bd4b5ebdce40.png";